
import superagent from "superagent";
import { sprintf } from "sprintf-js";
import {authorize_onboarding} from "../helper/authorize-token";
import {deep_assign, deep_copy } from "../../lib/js-utils";

const TDA_UPDATE = "TDA_UPDATE";
const TDA_CLEAR = "TDA_CLEAR";

const tdaUpdate = (data, index, username) => {
  return dispatch => {
    dispatch({
      type: TDA_UPDATE,
      data: data,
      index: index,
      username,
    })
  }
};

const LoadTdaData = (token, onboarding_token, index, user_list) => {
  return new Promise((resolve) => {
    return superagent.agent()
      .post("/api/onboarding/load-tda-data")
      .send({ index, user_list })
      .use(authorize_onboarding(token, onboarding_token))
      .then(result => {
        return resolve(result.body.data);
      });
  })
}

const tdaClear = () => {
  return dispatch => {
    dispatch({
      type: TDA_CLEAR,
    })
  }
};

const tdaReducer = (state = {}, action) => {

  const new_state = deep_copy(state);

  switch(action.type) {
    case TDA_UPDATE:
      if (action.index === -1) {
        // replace the entire thing
        return {
          ...state,
          ...action.data,
        };
      } else if (action.username) {
        const index = sprintf("%04d", action.index);
        deep_assign(new_state, [action.username, index], action.data);
        return new_state;
      } else {
        const index = sprintf("%04d", action.index);
        deep_assign(new_state, [index], action.data);
        return new_state;
      }

    case TDA_CLEAR:
      return {};

    default:
      return state;
  }
};

export { tdaReducer, tdaUpdate, tdaClear, TDA_UPDATE, LoadTdaData };
